// Components
import StrapiMedia from '@/components/atoms/StrapiMedia/StrapiMedia';
import RevealFadeIn from '@/components/reveal-animations/RevealFadeIn/RevealFadeIn';
import Text from '@/components/molecules/Text/Text';

// Types
import { FooterType } from '../FooterType';

// Styles
import styles from './FooterContactSection.module.css';

interface FooterContactSectionProps {
  preFooter: FooterType['preFooter'];
}

const animationPaths =
  // eslint-disable-next-line max-len
  'M1000,570H0V44.33s178.9-53.27,415.34-43C691.8,13.29,1000,161.72,1000,161.72Z;M1000,570H0V103.79S88.9-9.6,325.34.66C601.8,12.65,1000,101.19,1000,101.19Z;M1000,570H0V44.33s178.9-53.27,415.34-43C691.8,13.29,1000,161.72,1000,161.72Z';

function FooterContactSection({ preFooter }: FooterContactSectionProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <Text
            className={styles.contentInner}
            title={preFooter.title}
            paragraph={preFooter.paragraph}
            cta={preFooter.cta}
          />
        </div>
        <RevealFadeIn className={styles.head}>
          {preFooter?.doudou && <StrapiMedia image={preFooter.doudou} format="xlarge" className={styles.headImage} />}
        </RevealFadeIn>
      </div>

      <svg
        className={styles.backgroundShape}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 570"
        preserveAspectRatio="none"
        width="100%"
        height="100%"
      >
        <defs>
          <linearGradient id="footerGradient" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(-40)">
            <stop offset="0%" stopColor="var(--gradient-blue-start)" />
            <stop offset="100%" stopColor="var(--gradient-blue-end)" />
          </linearGradient>
        </defs>
        <path fill="url(#footerGradient)" className={styles.animated}>
          <animate attributeName="d" dur="10s" begin="0s" repeatCount="indefinite" values={animationPaths} />
        </path>
      </svg>
    </div>
  );
}

export default FooterContactSection;
